const aux = props => props.children;

export default aux;



// WEBPACK FOOTER //
// ./src/system/containers/Aux/index.jsx